<template>
  <div class="content_box">
    <!-- <div style="padding-bottom: 0.5rem; border-bottom: 0.18rem solid #f7f8fa">
      <div class="time_box">
        <div class="time_title">起始日期</div>
        <div class="start_end">2021-05-24</div>
        <img src="../assets/time.png" class="time" />
      </div>
      <div class="time_box">
        <div class="time_title">起始日期</div>
        <div class="start_end">2021-05-24</div>
        <img src="../assets/time.png" class="time" />
      </div>
      <div class="recharge_btn" @click="toCharge">立即充值</div>
    </div>-->
    <div class="history_box">
      <div class="history_item" v-for="item in recordList">
        <div class="history_time">{{item.transDate}}</div>
        <div
          style="
            margin-bottom:20px;
            border-right: 0.01rem solid #ededed;
            border-bottom: 0.01rem solid #ededed;
          "
        >
          <div class="history_table">
            <div style="display: flex">
              <div class="column">交费金额</div>
              <div class="data">{{item.amount}}</div>
            </div>
          </div>
          <div class="history_table">
            <div style="display: flex">
              <div class="column">交费方式</div>
              <div class="data">{{item.transTypeTitle}}</div>
            </div>
          </div>
          <div class="history_table">
            <div style="display: flex">
              <div class="column">操作员</div>
              <div class="data">{{item.operator}}</div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="!canScroll"
        style="font-size: 0.24rem;color: #cecece;text-align: center; margin-top: 10px;"
      >暂时没有更多了</div>
    </div>
    <van-popup v-model="show" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="year-month"
        title="选择年月"
        :min-date="minDate"
        :max-date="maxDate"
        :formatter="formatter"
        @confirm="confirm"
        @cancel="cancel"
      />
    </van-popup>
  </div>
</template>
<script>
import { queryTransactionRecordList } from "@/api/user.js";
import Vue from "vue";
import { Notify, DatetimePicker, Popup } from "vant";
Vue.use(Notify);
Vue.use(DatetimePicker);
Vue.use(Popup);
export default {
  data() {
    return {
      consId: "",
      canScroll: true,
      show: false,
      pageSize: 5,
      currentPage: 1,
      recordList: [],
      currentMonth: "",
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2025, 10, 1),
      currentDate: new Date(2021, 0, 17)
    };
  },
  created() {
    this.consId = this.$route.query.consId ? this.$route.query.consId : "";
    this.queryTransactionRecordList();
  },

  mounted() {
    var vm = this;
    window.onscroll = function() {
      //获得页面向左、向上卷动的距离
      function getScroll() {
        return {
          left:
            window.pageXOffset ||
            document.documentElement.scrollLeft ||
            document.body.scrollLeft ||
            0,
          top:
            window.pageYOffset ||
            document.documentElement.scrollTop ||
            document.body.scrollTop ||
            0
        };
      }
      var sTop = getScroll().top;
      if (sTop + window.innerHeight >= document.body.offsetHeight - 10) {
        if (vm.canScroll) {
          vm.currentPage++;
          vm.queryTransactionRecordList();
        }
      }
    };
  },
  methods: {
    queryTransactionRecordList() {
      queryTransactionRecordList({
        consId: this.consId,
        currentPage: this.currentPage,
        pageSize: this.pageSize
      }).then(res => {
        if (res.data.status == 200) {
          if (this.currentPage <= res.data.page.pages) {
            res.data.object.forEach(element => {
              this.recordList.push(element);
            });
          } else {
            this.canScroll = false;
          }
        }
      });
    },
    toCharge() {},
    initTime(t) {
      let d = new Date(t).getTime(new Date(t));
      let time = new Date(d + 8 * 3600 * 1000)
        .toJSON()
        .substr(0, 19)
        .replace("T", " ")
        .replace(/\./g, "-");
      return time;
    },
    confirm(data) {
      this.month = this.initTime(data).substring(0, 7);
      //   this.queryPowerUseBill();
    },
    cancel() {
      this.show = false;
    },
    formatter(type, val) {
      if (type === "year") {
        return `${val}年`;
      } else if (type === "month") {
        return `${val}月`;
      }
      return val;
    }
  }
};
</script>

<style scoped>
.data {
  border-left: 0.01rem solid #ededed;
  border-top: 0.01rem solid #ededed;
  border-color: #ededed;
  font-size: 0.24rem;
  background-color: #f9faf7;
  height: 0.73rem;
  line-height: 0.73rem;
  color: #666;
  width: 66%;
  padding-left: 0.5rem;
}
.column {
  width: 33%;
  border-left: 0.01rem solid #ededed;
  border-top: 0.01rem solid #ededed;
  border-color: #ededed;
  font-size: 0.24rem;
  background-color: #f9faf7;
  height: 0.73rem;
  line-height: 0.73rem;
  color: #666;
  text-align: center;
}
.history_box {
  text-align: left;
  margin: 0 0.5rem;
  padding-top: 0.5rem;
}
.history_time {
  color: #707070;
  line-height: 0.21rem;
  margin-bottom: 0.16rem;
  font-size: 0.22rem;
}
.time_box {
  display: flex;
  margin: 0 0.5rem;
  font-size: 0.24rem;
  align-items: center;
  line-height: 0.77rem;
  justify-content: space-around;
  border-bottom: 1px solid #ededed;
}
.recharge_btn {
  color: #fff;
  height: 0.6rem;
  font-size: 0.26rem;
  line-height: 0.6rem;
  margin: 0rem 0.3rem;
  margin-top: 0.3rem;
  background: #50c7a1;
  border-radius: 0.06rem;
}
</style>